// Lazy stage loaders: each stage (content + its new instruments) is its own chunk (§9.15).
import type { StageDef } from '../types.ts';

const LOADERS: Record<string, () => Promise<StageDef>> = {
  _test: () => import('./_test.ts').then((m) => m.testStage),
  prologue: () => import('./prologue.ts').then((m) => m.prologue),
  ch01: () => import('./ch01.ts').then((m) => m.ch01),
  ch02: () => import('./ch02.ts').then((m) => m.ch02),
  ch03: () => import('./ch03.ts').then((m) => m.ch03),
  ch04: () => import('./ch04.ts').then((m) => m.ch04),
  ch05: () => import('./ch05.ts').then((m) => m.ch05),
  ch06: () => import('./ch06.ts').then((m) => m.ch06),
  ch07: () => import('./ch07.ts').then((m) => m.ch07),
  ch08: () => import('./ch08.ts').then((m) => m.ch08),
  ch09: () => import('./ch09.ts').then((m) => m.ch09),
  ch10: () => import('./ch10.ts').then((m) => m.ch10),
  ch11: () => import('./ch11.ts').then((m) => m.ch11),
  ch12: () => import('./ch12.ts').then((m) => m.ch12),
  ch13: () => import('./ch13.ts').then((m) => m.ch13),
  ch14: () => import('./ch14.ts').then((m) => m.ch14),
  ch15: () => import('./ch15.ts').then((m) => m.ch15),
  epilogue: () => import('./epilogue.ts').then((m) => m.epilogue),
};

export function registerStageLoader(id: string, loader: () => Promise<StageDef>): void {
  LOADERS[id] = loader;
}

export const hasStage = (id: string): boolean => id in LOADERS;

export async function loadStage(id: string): Promise<StageDef> {
  const l = LOADERS[id];
  if (!l) throw new Error(`Stage ${id} is not built yet.`);
  return l();
}
